import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ScrollToTop from "react-scroll-to-top";
import Footer from '../components/Footer.js';
import Navbar from '../components/Navbar.js';
function RootLayout() {
    const location = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);
  
    return(
        <>
            <Navbar />  
            <Outlet />    
            <Footer />
            <ScrollToTop smooth />
        </>
    );
}
export default RootLayout;